import { Box, useTheme } from '@mui/material';
import { APP_NAME, getLogoSrc } from '../Shared/branding';

const Logo = ({ variant = 'theme', sx, ...props }) => {
	const theme = useTheme();
	const src = getLogoSrc(theme.palette.mode, variant);

	return <Box component="img" src={src} alt={APP_NAME} sx={sx} {...props} />;
};

export default Logo;
